import AccountBoxIcon from '@mui/icons-material/AccountBox';
import GroupsIcon from '@mui/icons-material/Groups';
import { Box, Container, Tabs } from '@mui/material';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { INSTALLER_TYPES } from '../../../constants';
import { useAuth } from '../../../hooks';
import { StyledTab } from '../../StyledTab';

const TabStyle = {
  width: '12rem',
  fontSize: '16px',
  py: 0,
  '&.Mui-selected': {
    py: 0,
    '&:first-of-type': {
      borderTopLeftRadius: 16,
    },
  },
  '&.MuiButtonBase-root': {
    minHeight: '55px',
  },
};

export default function SettingsLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  const currentTab = location.pathname.split('/').pop() || 'profile';

  const handleTabChange = (_event: React.SyntheticEvent, newValue: string) => {
    navigate(`/settings/${newValue}`);
  };

  return (
    <Container maxWidth="lg" sx={{ pt: 6.25, pb: 3 }}>
      <Box
        flex={1}
        bgcolor="background.paper"
        borderRadius={1}
        overflow="hidden"
      >
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          style={{ background: '#f9fbfd' }}
          sx={{
            '& .MuiTabs-indicator': {
              backgroundColor: 'transparent',
            },
            '.MuiTabs-flexContainer': {
              borderBottom: (theme) =>
                `1px solid ${theme.palette.border.input}`,
            },
          }}
        >
          <StyledTab
            label="My Profile"
            value="profile"
            iconPosition="start"
            icon={<AccountBoxIcon />}
            sx={TabStyle}
          />

          {user?.installer_role === INSTALLER_TYPES.ADMIN ? (
            <StyledTab
              label="Manage Team"
              value="team"
              iconPosition="start"
              icon={<GroupsIcon />}
              sx={TabStyle}
            />
          ) : null}
        </Tabs>

        <Box
          sx={{
            border: (theme) => `1px solid ${theme.palette.border.input}`,
            borderTopWidth: 0,
            borderBottomLeftRadius: 16,
            borderBottomRightRadius: 16,
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Container>
  );
}
